// State
const state = {
  validationRules: {
    textRules: [(v) => !!v || "Field is required"],
    percentRules: [
      (v) => !!v || "Field is required",
      (v) => (v && !isNaN(v)) || "Insert a number",
      (v) => (v >= 0 && v <= 100) || "Percent must be between 0 and 100",
    ],
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) =>
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
        "E-mail must be valid",
    ],
    passwordRules: [
      (v) => !!v || "Field is required",
      (v) => (v && v.length >= 8) || "Min 8 characters",
    ],
    documentFileRules: [
      (v) => !!v || "Field is required",
      (v) => !v || v.size < 2000000 || "File size should be less than 2 MB!",
    ],
    urlRules: [
      (v) => !!v || "URL is required",
      (v) =>
        /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?.../.test(v) ||
        "URL must be valid",
    ],
    mobileRules: [(v) => !!v || "Mobile is required"],
    logoRules: [
      (v) => !!v || "Field is required",
      (v) => !v || v.size < 2000000 || "File size should be less than 2 MB!",
    ],
  },
  confirmPasswordRules: {
    required: (value) => !!value || "Field is required.",
    min: (v) => v.length >= 8 || "Min 8 characters",
  },
};

// Getters (if you need them in the future)
const getters = {};

// Mutations (if you need them in the future)
const mutations = {};

export default {
  namespaced: true,
  strict: true,
  state,
  getters,
  mutations,
};
